module.exports = __webpack_public_path__ + "static/media/header-logo.99550fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo.svg
// module id = 24
// module chunks = 0